import { ENV } from "./env";
export var PROD_URL = 'https://tokenlon.im';
export var STAGING_URL = 'https://tokenlon.imstaging.works';
export var DEV_URL = 'https://tokenlon.imdev.works';
export var HOST = ENV.production ? PROD_URL : ENV.staging ? STAGING_URL : DEV_URL;